module.exports = __webpack_public_path__ + "media/images/success-img/layer-3-8e40f4f384e499e8d51209f0302ffa18.png";